namespace TabAurous.Common {
    export enum BloodGroups {
        OPositive = 0,
        APositive = 1,
        BPositive = 2,
        ABPositive = 3,
        ABNegative = 4,
        ANegative = 5,
        BNegative = 6,
        ONegative = 7
    }
    Serenity.Decorators.registerEnumType(BloodGroups, 'TabAurous.Common.BloodGroups', 'HR.BloodGroups');
}
